<template>
    <v-app>
        <v-container>
            <v-layout row>
                <v-flex xs12 sm8 offset-sm2>
                    <v-card>
                        <v-card-title primary-title>
                            <h3 class="mx-auto teal--text text--accent-4 font-weight-regular">
                                <v-icon class="pb-1" color="teal accent-4">
                                    lock
                                </v-icon>
                                Login:
                            </h3>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-form ref="form">
                                    <v-layout class="pb-2" row>
                                        <v-flex xs12>
                                            <form>
                                                <v-text-field label="E-mail"
                                                              v-model="user.email"
                                                              required
                                                              :rules="emailRules"
                                                              @keyup.enter="attemtpToLog">
                                                </v-text-field>
                                            </form>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout class="pb-2" row>
                                        <v-flex xs12>
                                            <v-text-field label="Password"
                                                          v-model="user.password"
                                                          :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                                                          required
                                                          :type="showPassword ? 'text' : 'password'"
                                                          :rules="passwordRules"
                                                          @click:append="showPassword = !showPassword"
                                                          @keyup.enter="attemtpToLog">
                                            </v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <div v-if="loginError" class="mt-2 alert alert-danger" role="alert">
                                        <strong>Something went wrong !</strong> Try once again
                                    </div>
                                    <div v-if="registrationMessage" class="alert alert-success" role="alert">
                                        <strong>Well done!</strong> You successfully register. Just log in now !
                                    </div>
                                    <v-layout row>
                                        <v-flex xs12 class="text-center">
                                            <v-btn color="teal accent-4 white--text" @click="attemtpToLog">Log In
                                            </v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-form>
                            </v-container>
                        </v-card-text>
                        <v-card-text>
                            <h5 class="text-center font-weight-regular">
                                Not registered yet?
                                <v-btn color="teal accent-4 white--text" to="/registration">
                                    Go to registration Page &nbsp
                                    <v-icon small>
                                        arrow_forward
                                    </v-icon>
                                </v-btn>
                            </h5>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </v-app>
</template>

<script>
    export default {
        data() {
            return {
                emailRules: [
                    v => !!v || 'E-mail is required',
                    v => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        .test(v) || 'E-mail must be valid',
                ],
                passwordRules: [
                    v => v.length > 5 || 'Minimum 6 characters',
                ],
                showPassword: false,
                user: {
                    email: '',
                    password: ''
                },
                registrationMessage: '',
                loginError: false
            }
        },
        mounted() {
            this.registrationMessage = this.$route.query.registered;
        },
        methods: {
            attemtpToLog() {
                if (this.$refs.form.validate()) {
                    this.$http.post('/auth/login', this.user).then((response) => {
                            if (response.status === 200) {
                                this.$store.dispatch('updateToken', response.data.token);
                                this.$router.push('/todo')
                            }
                        },
                        (error) => {
                            this.loginError = true;
                        })
                }
            }
        }
    }
</script>

<style>
    .v-text-field__slot label {
        animation: none !important;
    }
</style>

